export default __webpack_public_path__ + "static/Tree_Sap_Tap-aea391f20f5644386e7e396ab3d95697.png";